// ** React Imports
import { memo, useMemo, useState } from 'react'
// ** Icon Imports
import { Icon } from '@iconify/react'

// ** MUI Imports
import { Box, Tooltip } from '@mui/material'

// ** SCSS Imports
import './index.scss'

const IconifyIcon = ({
  icon = null,
  className = '',
  SvgComponent = null,
  title = '',
  onClick,
  hoverEffect = false,
  hoverBoxStyle = {},
  nonHoverBoxStyle = {},
  disabled = false,
  style = {},
  isSvgElement = false,
  sx = {},
  ...rest
}) => {
  // State
  const [open, setOpen] = useState(false)

  // variable
  const { position, top, left, right, bottom, ...restStyles } = useMemo(() => {
    const { position, top, left, right, bottom, ...restStyles } = style

    return {
      position,
      top,
      left,
      right,
      bottom,
      ...restStyles
    }
  }, [style])

  const positionStyle = useMemo(() => {
    return {
      ...(position ? { position } : {}),
      ...(top ? { top } : {}),
      ...(bottom ? { bottom } : {}),
      ...(left ? { left } : {}),
      ...(right ? { right } : {})
    }
  }, [position, left, right, top, bottom])

  const mergedStyles = useMemo(() => {
    return {
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      ...restStyles
    }
  }, [restStyles, disabled])

  // Handers
  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = () => {
    setOpen(true)
  }

  return (
    <Tooltip
      arrow
      open={open}
      title={title}
      onClose={handleClose}
      onOpen={handleOpen}
    >
      {hoverEffect ? (
        <Box
          className={`icon-hover ${
            disabled ? 'disabled-icon' : ''
          } ${className}`}
          sx={{
            display: 'flex',
            ...hoverBoxStyle
          }}
          {...(!disabled && onClick
            ? {
                onClick: (e) => {
                  handleClose()
                  onClick(e)
                }
              }
            : {})}
        >
          {SvgComponent ? (
            <Box sx={{ ...sx }} {...rest}>
              {isSvgElement ? SvgComponent : <SvgComponent />}
            </Box>
          ) : (
            <Icon
              icon={icon}
              fontSize="1.375rem"
              style={{ ...mergedStyles, pointerEvents: 'none' }}
              {...rest}
            />
          )}
        </Box>
      ) : SvgComponent ? (
        <Box
          className={`${disabled ? 'disabled-icon' : ''}  ${className}`}
          {...(!disabled && onClick
            ? {
                onClick: (e) => {
                  handleClose()
                  onClick(e)
                }
              }
            : {})}
          sx={{ ...sx, ...nonHoverBoxStyle }}
          {...rest}
        >
          {isSvgElement ? SvgComponent : <SvgComponent />}
        </Box>
      ) : (
        <Box
          className={`${className}`}
          {...(!disabled && onClick
            ? {
                onClick: (e) => {
                  handleClose()
                  onClick(e)
                }
              }
            : {})}
          sx={{ display: 'flex', ...positionStyle, ...nonHoverBoxStyle }}
        >
          <Icon
            icon={icon}
            fontSize="1.375rem"
            style={{ ...mergedStyles, pointerEvents: 'none' }}
            {...rest}
          />
        </Box>
      )}
    </Tooltip>
  )
}

export default memo(IconifyIcon)
